import { createSelector } from 'reselect';
import { appState } from './utils';
const partnersNameSpace = createSelector(appState, ({ partners }) => partners);
export const getAllPartners = createSelector(partnersNameSpace, data => data.partners);
export const getSupportedCountries = country => createSelector(getAllPartners, (partners = []) => partners.some(partner => partner.supportedCountries.includes(country)));
